import { BrowserRouter as Router } from 'react-router-dom';
import Container from './container/Container';
import { SiteProvider } from './context/SiteContext';
import { SiteTrackingProvider } from './context/SiteTrackingContext';
import { RedirectProvider } from './context/RedirectContext';
import { LocalProvider } from './context/LocalContext';
import { AdminProvider } from './context/AdminContext';
import { TravelProvider } from './context/TravelContext';
import { CarRentalProvider } from './context/CarRentalContext';
import { HotelBookingProvider } from './context/HotelBookingContext';
import SitePopupModal from './components/SitePopupModal/SitePopupModal';
import DealPopups from './components/DealPopups/DealPopups';
import './assets/style.css';

function App() {
  return (
    <div className="app">
      <SiteProvider>
        <Router>
          <SiteTrackingProvider>
            <RedirectProvider>
              <SitePopupModal />
              <AdminProvider>
                <LocalProvider>
                  <TravelProvider>
                    <CarRentalProvider>
                      <HotelBookingProvider>
                        <DealPopups />
                        <Container />
                      </HotelBookingProvider>
                    </CarRentalProvider>
                  </TravelProvider>
                </LocalProvider>
              </AdminProvider>
            </RedirectProvider>
          </SiteTrackingProvider>
        </Router>
      </SiteProvider>
    </div>
  );
}

export default App;
